export enum QueueProviders {
  Firestore = "Firestore",
  PubSub = "PubSub",
  File = "File",
}

export type QueueType = keyof typeof QueueProviders | QueueProviders;
